/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q6Inputs */

const es_marketplace_seo_spain_faq_q6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo alquilar un velero sin experiencia?`)
};

const gl_marketplace_seo_spain_faq_q6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podo aluguer un veleiro sen experiencia?`)
};

const en_marketplace_seo_spain_faq_q6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I rent a sailboat with no experience?`)
};

/**
* | output |
* | --- |
* | "Can I rent a sailboat with no experience?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q6Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q6 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q6Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q6Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q6(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q6(inputs)
	return es_marketplace_seo_spain_faq_q6(inputs)
});